import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useBranding } from "@/context/BrandingContext";
import { imageUrl } from "@/lib/api";
import { resolveBusinessCta } from "@/lib/storefrontContent";

/* BusinessCTASection — presentasi milik TEMPLATE, konten milik TENANT.
   Sederhana: badge + judul + deskripsi + satu tombol. Tanpa countdown/kupon/statistik. */
export function BusinessCTASection() {
  const { branding } = useBranding();
  const cta = resolveBusinessCta(branding);
  if (!cta) return null;

  const style = cta.backgroundStyle === "image"
    ? { backgroundImage: `url(${imageUrl(cta.backgroundImage)})` }
    : undefined;
  const btnCls = "gcp-cta-button inline-flex min-h-11 items-center gap-2 px-6 font-bold text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2";
  const button = cta.external ? (
    <a href={cta.href} target="_blank" rel="noopener noreferrer" className={btnCls} data-testid="business-cta-button">
      {cta.buttonText} <ArrowUpRight size={16} aria-hidden="true" />
    </a>
  ) : (
    <Link to={cta.href} className={btnCls} data-testid="business-cta-button">
      {cta.buttonText} <ArrowUpRight size={16} aria-hidden="true" />
    </Link>
  );

  return (
    <section className="storefront-section" aria-labelledby="business-cta-title" data-testid="business-cta">
      <div className={`gcp-cta gcp-cta--${cta.backgroundStyle}`} style={style}>
        <div className="gcp-cta-inner">
          <div className="min-w-0 max-w-2xl">
            <div className="gcp-eyebrow" data-testid="business-cta-badge">{cta.badge}</div>
            <h2 id="business-cta-title" className="gcp-cta-title" data-testid="business-cta-title">{cta.title}</h2>
            <p className="gcp-cta-desc" data-testid="business-cta-desc">{cta.description}</p>
          </div>
          <div className="shrink-0">{button}</div>
        </div>
      </div>
    </section>
  );
}
